// ハンバーガーメニュー
$(document).on('turbolinks:load',function() {
  $('.el_nav_toggleBtn').on('click', function() {
    $(this).toggleClass('active');
    $('.el_header_nav_sp').fadeToggle();
  });

  $('.el_header_nav a').on('click', function() {
    $(".el_nav_toggleBtn").toggleClass('active');
    $('.el_header_nav_sp').fadeToggle();
  });
});